import { render, staticRenderFns } from "./ChooseTickets.vue?vue&type=template&id=1dbe3fd0&"
import script from "./ChooseTickets.vue?vue&type=script&lang=js&"
export * from "./ChooseTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports